import Vue from 'vue';

Vue.component('staff-profile', () =>
    import(/* webpackChunkName: 'outlet' */ './staff/staff_profile.vue'),
);
